import axios from 'axios'

import { Http } from './http.init'
import { ResponseWrapper, ErrorWrapper } from './util'
import $store from '../store'
import $router from '../router'

import { API_URL } from '../.env'
export class AuthService {
  /**
   ******************************
   * @API
   ******************************
   */

  static async makeLogin({ email, password }) {
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      })

      if (response.data.token) {
        _setAuthData({
          accessToken: response.data.token,
          exp: new Date().setFullYear(new Date().getFullYear() + 1),
        })
      }

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      if (error.response.status === 422) {
        error.response.data.errors = {
          email: ['Неверно указан e-mail или пароль.'],
        }
      }

      throw new ErrorWrapper(error)
    }
  }

  static async loginCheckCode({ code, session }) {
    try {
      const response = await axios.post(`${API_URL}/auth/login-check-code`, {
        code,
        session,
      })

      if (response.data.token) {
        _setAuthData({
          accessToken: response.data.token,
          exp: new Date().setFullYear(new Date().getFullYear() + 1),
        })
      }

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      if (error.response.status === 422) {
        error.response.data.errors = {
          code: ['Неверный код или его срок действия истёк.'],
        }
      }

      throw new ErrorWrapper(error)
    }
  }

  static async makeLogout() {
    try {
      const response = await new Http({ auth: true }).get(`${API_URL}/auth/logout`, {})
      _resetAuthData()
      $router.push({ name: 'login' }).catch(() => {})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async changePassword(payload = {}) {
    try {
      const response = await new Http({ auth: true }).post('auth/change-password', {
        ...payload,
      })

      if (response.data.token) {
        _setAuthData({
          accessToken: response.data.token,
          exp: new Date().setFullYear(new Date().getFullYear() + 1),
        })
      }

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async getSessions() {
    try {
      const response = await new Http({ auth: true }).get('auth/sessions')

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async terminateSessions() {
    try {
      const response = await new Http({ auth: true }).delete('auth/sessions')

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async deleteSession(session) {
    try {
      const response = await new Http({ auth: true }).delete(`auth/sessions/${session.id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   * Send reset password link to user email.
   */
  static async sendLink(params) {
    try {
      const response = await new Http({ auth: true }).post('auth/resetpassword', {
        ...params,
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   * Set new password for user.
   *
   * @param {Object} payload Request payload.
   * @returns {Object: <ResponseWrapper>}
   */
  static async setPassword(payload = {}) {
    try {
      const response = await new Http({ auth: true }).post('auth/resetpassword/new', {
        ...payload,
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   * Validate key string from email link.
   *
   * @param {*} payload Request payload.
   * @returns {Object: <ResponseWrapper>}
   */
  static async checkKey(payload = {}) {
    try {
      const response = await new Http({ auth: true }).get('auth/resetpassword/check', {
        params: {
          ...payload,
        },
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   ******************************
   * @METHODS
   ******************************
   */

  static getBearer() {
    const token = this.getLocalStorageBearer()

    return `Bearer ${token}`
  }

  static getLocalStorageBearer() {
    return localStorage.getItem('token')
  }

  static setBearer(accessToken) {
    localStorage.setItem('token', accessToken)
  }

  static removeLocalStorageBearer() {
    localStorage.removeItem('token')
  }

  static resetAuth() {
    _resetAuthData()
    $router.push({ name: 'login' }).catch(() => {})
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */

function _resetAuthData() {
  // reset userData in store
  $store.commit('user/SET_CURRENT_USER', {})
  $store.commit('auth/SET_ATOKEN_EXP_DATE', null)
  // reset tokens
  AuthService.setBearer('')
  AuthService.removeLocalStorageBearer()
}

function _setAuthData({ accessToken, exp } = {}) {
  AuthService.setBearer(accessToken)
  $store.commit('auth/SET_ATOKEN_EXP_DATE', exp)
}
